export const sign_up_base_url = "https://utils.ntt.inaipi.ae/publicservice/v1/usermanagement";
